import { regionCodes } from '../../referenceData';
import customGroupsService from '../../services/customGroupsService';

export default (locCode) => {
  // Custom groups are not countries
  if (customGroupsService.urlUtils.parseUrlParam(locCode)) {
    return false;
  }

  // If it's not a region code and not a custom group, it's a country
  return !regionCodes.includes(locCode);
};
